
import { defineComponent, toRefs, reactive, ref, watch, computed } from 'vue'

export default defineComponent({
  name: 'Video',
  props: {
    /** 视频类型  video/mp4 */
    videoType: {
      type: String,
      default: 'video/mp4'
    },
    /** 视频封面 */
    videoPoster: {
      type: String,
      //   default:()=>{
      //     return require("../assets/222.png")
      //   }
    },
    /** 视频地址 */
    videoSrc: {
      type: String,
      //   default:()=>{
      //     return require("../assets/111.mp4")
      //   }
    },
    /** 视频比列 */
    videoAspectRatio: {
      type: String,
      default: '16:9'
    },
    /** 是否点击之后自动全屏播放 1.默认为 false 则点击之后会自动全屏 2.true 则点击之后不会自动全屏播放 */
    noClickFull: {
      type: Boolean,
      default: false
    },
    /** 显示的按钮 例如是否显示全屏按钮等  */
    controlBar: {
      type: Object,
      default: () => {
        return {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        }
      }
    },
  },
  setup(prop) {
    const restate = reactive({
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: prop.videoAspectRatio, // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: prop.videoType, // 类型
            src: prop.videoSrc, // url地址
          },
        ],
        width: document.documentElement.clientWidth,
        poster: prop.videoPoster, // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: prop.controlBar
      },
    })
    let videoPlay=ref()
    const onPlayerPlay = (player: any) => {
      if(!prop.noClickFull){
         full(player)
      }else{
        player.play(); 
      }
     
    }
    /** 暂停 全屏下会无作用 */
    const onPlayerPause = (player: any) => {
      if(player){
         player.pause(); 
      }else{
        videoPlay.value.player.pause()
        
      }

    }
    // 全屏播放处理
    const full = (element: any) => {
      //做兼容处理
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {
        // var docHtml = document.documentElement;
        // var docBody = document.body;
        const videobox: any = document.getElementsByClassName("video-player");
        var cssText = "width:100%;height:100%;overflow:hidden;";
        // docHtml.style.cssText = cssText;
        // docBody.style.cssText = cssText;
        videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
        // document.IsFullScreen = true;
        videobox.IsFullScreen = true;
      }
    }

    return {
      ...toRefs(restate),
      videoPlay,
      onPlayerPlay,
      onPlayerPause
    }
  }

})
